import React from "react";
import {
  AbsoluteFill,
  interpolate,
  Sequence,
  spring,
  useCurrentFrame,
  useVideoConfig,
} from "remotion";

const WORDS = ["EDIT", "TANPA", "TIMELINE", "SERET-KODE", "RENDER", "AUTO"];

const Word: React.FC<{ children: React.ReactNode; hue: number }> = ({ children, hue }) => {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();
  const inSpring = spring({ frame, fps, config: { damping: 14, stiffness: 100 } });
  const y = interpolate(inSpring, [0, 1], [80, 0]);
  const rotate = interpolate(inSpring, [0, 1], [-8, 0]);
  const opacity = interpolate(frame, [0, 6], [0, 1], { extrapolateRight: "clamp" });
  const out = interpolate(frame, [40, 55], [1, 0], {
    extrapolateLeft: "clamp",
    extrapolateRight: "clamp",
  });

  return (
    <AbsoluteFill
      style={{
        justifyContent: "center",
        alignItems: "center",
        opacity: opacity * out,
      }}
    >
      <div
        style={{
          transform: `translateY(${y}px) rotate(${rotate}deg)`,
          background: `linear-gradient(90deg, hsl(${hue} 90% 55%), hsl(${hue + 45} 90% 60%))`,
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          fontSize: 170,
          fontWeight: 900,
          letterSpacing: -6,
          fontFamily: "Inter, Arial, sans-serif",
        }}
      >
        {children}
      </div>
    </AbsoluteFill>
  );
};

export const CarrooPromo: React.FC<{ brand: string; tagline: string }> = ({
  brand,
  tagline,
}) => {
  const frame = useCurrentFrame();
  const { durationInFrames } = useVideoConfig();

  const barWidth = interpolate(frame, [0, durationInFrames], [0, 100]);
  const brandIn = spring({ frame: frame - 130, fps: 30, config: { damping: 15 } });
  const brandOpacity = interpolate(frame, [130, 150], [0, 1], {
    extrapolateLeft: "clamp",
    extrapolateRight: "clamp",
  });

  return (
    <AbsoluteFill
      style={{
        background: "linear-gradient(160deg, #061024, #1a0f36 60%, #060b18)",
        fontFamily: "Inter, Arial, sans-serif",
      }}
    >
      <Sequence from={10} durationInFrames={60}>
        <Word hue={205}>EDIT</Word>
      </Sequence>
      <Sequence from={45} durationInFrames={60}>
        <Word hue={280}>TANPA</Word>
      </Sequence>
      <Sequence from={80} durationInFrames={60}>
        <Word hue={330}>TIMELINE</Word>
      </Sequence>
      <Sequence from={112} durationInFrames={70}>
        <Word hue={160}>OTOMATIS</Word>
      </Sequence>

      <AbsoluteFill style={{ justifyContent: "center", alignItems: "center" }}>
        <div
          style={{
            opacity: brandOpacity,
            transform: `scale(${interpolate(brandIn, [0, 1], [0.85, 1])})`,
            textAlign: "center",
          }}
        >
          <div
            style={{
              color: "white",
              fontSize: 210,
              fontWeight: 900,
              letterSpacing: -8,
              lineHeight: 1,
            }}
          >
            {brand}
          </div>
          <div
            style={{
              color: "rgba(170,195,255,0.9)",
              fontSize: 48,
              marginTop: 24,
              letterSpacing: 1,
            }}
          >
            {tagline}
          </div>
        </div>
      </AbsoluteFill>

      <div
        style={{
          position: "absolute",
          bottom: 0,
          left: 0,
          height: 14,
          width: `${barWidth}%`,
          background: "linear-gradient(90deg, #4f8cff, #b45cff, #ff5c9d)",
        }}
      />
    </AbsoluteFill>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
